import {
  ECOMMERCE_ACCOUNT_SESSION_STATUS,
  type EcommerceAccountAuthRecord,
  type EcommerceAccountDetail,
} from '../api';

type EcommerceAccountSessionLike = (Partial<Pick<
  EcommerceAccountAuthRecord,
  'account_type' | 'business_type' | 'session_status' | 'session_status_message'
>> & {
  is_demo?: boolean;
}) | null | undefined;

function normalizeSessionStatus(status?: string | null) {
  return String(status || '').trim().toUpperCase();
}

function normalizeBusinessType(businessType?: string | null) {
  return String(businessType || '').trim().toUpperCase();
}

export function isEcommerceAccountSessionExpired(record?: EcommerceAccountSessionLike) {
  if (record?.is_demo) {
    return false;
  }
  return normalizeSessionStatus(record?.session_status) === ECOMMERCE_ACCOUNT_SESSION_STATUS.EXPIRED;
}

export function resolveEcommerceAccountSessionLabel(status?: string | null) {
  return normalizeSessionStatus(status) === ECOMMERCE_ACCOUNT_SESSION_STATUS.EXPIRED ? '已过期' : '正常';
}

export function resolveEcommerceAccountSessionMessage(record?: EcommerceAccountSessionLike) {
  const businessType = normalizeBusinessType(record?.business_type);
  if (businessType === 'BUYING') {
    return '所绑定的抖音百应账号登录态已过期，请重新登录后再操作';
  }
  if (businessType === 'SELF_OPERATED') {
    return '所绑定的抖店账号登录态已过期，请重新登录后再操作';
  }
  return '所绑定的账号登录态已过期，请重新登录后再操作';
}

export function isEcommerceAccountSessionExpiredMessage(message?: string | null) {
  const text = String(message || '').trim();
  if (!text) {
    return false;
  }
  return [
    '账号未登录',
    '未登录',
    '登录态已过期',
    '登录已过期',
    '登录态失效',
    '登录失效',
    '请重新登录',
  ].some((keyword) => text.includes(keyword));
}

export function assertEcommerceAccountSessionActive(record?: EcommerceAccountSessionLike) {
  if (!isEcommerceAccountSessionExpired(record)) {
    return;
  }
  throw new Error(resolveEcommerceAccountSessionMessage(record));
}

export function isEcommerceAccountDetailSessionExpired(detail?: EcommerceAccountDetail | null) {
  return isEcommerceAccountSessionExpired(detail);
}
